import { IconRestore, IconSave } from '../Icon'

const SubmitButton = (props: Props) => {
    return (
        <button disabled={!!props.disable} type={!!props.onClick ? 'button' : "submit"} className={`btn btn-success flex gap-x-2 w-fit ${props.className}`}
            onClick={!!props.onClick ? props.onClick : undefined}
        >
            {!!props.disable ?
                <>
                    <IconRestore className='animate-spin size-5' />
                    Saving ...
                </> :
                <>
                    <IconSave className='seize-5' />
                    Save
                </>
            }
        </button>
    )
}

interface Props {
    className?: string,
    disable?: boolean
    onClick?: () => void
}

export default SubmitButton